// components/Card.jsx
import React from 'react';
import './card.css'; // You'll create this or use your existing CSS
import {Tooltip} from 'antd'; // Import Tooltip

function Card({item,dataSection}) { // Pass dataSection as prop to calculate difference
    // Calculate the difference for coloring
    const rankDifference = dataSection - item.min_section;
    let colorClass = '';

    if(rankDifference > 150) {
        colorClass = 'rank-diff-blue'; // User's rank is significantly higher (worse) than school's min rank
    } else if(rankDifference >= -150 && rankDifference <= 150) {
        colorClass = 'rank-diff-yellow'; // User's rank is close to the school's min rank
    } else if(rankDifference < -150) {
        colorClass = 'rank-diff-green'; // User's rank is significantly lower (better) than school's min rank
    }

    return (
        <div className={`item-container ${colorClass}`} key={item.school_id}> {/* key is handled by the map function in the parent usually, but good to have here too if standalone */}
            <div className="item-icon-wrapper">
                <img src={`/api/school/icon/${item.school_id}`} alt={`${item.school_name} logo`} />
                <span className="item-rank-position">
                    <div className="first-rank-info">
                        {item.max_section > 0 && <span className="muted-label"> {item.max_section}</span>}
                        <span className="rank-value">{item.min_section}</span>
                    </div>

                    <div className="secondary-rank-info">
                        {item.max > 0 && <span className="muted-label">{item.max} ~ </span>}
                        <span className="muted-label">{item.min}</span>
                    </div>
                </span>
            </div>
            <div className="item-content-details">
                <div className="primary-info-row">
                    <span className="university-name-small">{item.school_name}</span>
                    {item.sp_name && <span className="major-name-emphasized">{item.sp_name}</span>}
                    {item.sg_name && <span className="special-group-name">{item.sg_name}</span>}
                </div>

                <div className="secondary-info-row">
                    {item.sg_info && <span className="special-group-subtitle">{item.sg_info}</span>}
                    <span className="batch-name-subtitle">{item.local_batch_name}</span>
                    <span className="enrollment-count-subtitle">{item.num} 人</span>
                </div>
                {item.remark && (
                    <Tooltip title={item.remark_tooltip || item.remark} color='#87d068' overlayInnerStyle={{whiteSpace: 'pre-line'}} >
                        <div className="item-remark-description">{item.remark}
                        </div>
                    </Tooltip>
                )}
            </div>
        </div>
    );
}

export default Card;